import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import useClickOutside from './hooks/useClickOutside';
import useKeypress from './hooks/useKeypress';
import useTrapFocus from './hooks/useTrapFocus';import './Modal.scss';
{/* Modal est une fenêtre modale qui s'affiche au-dessus du contenu principal. Il utilise des props comme isOpen pour contrôler son affichage et onClose pour la fermer. La modale est rendue uniquement si isOpen est vrai. */ }

function Modal({ isOpen, onClose, content, id, className = 'modal', borderColor }) {
    const modalRef = useRef();

    useClickOutside(modalRef, isOpen, onClose);
    useKeypress('Escape', isOpen, onClose);
    useTrapFocus(modalRef, isOpen);

    if (!isOpen) return null;

    return (
        <div className={`${className}-background`}>
            <div ref={modalRef} id={id} className={`${className}-content ${borderColor && "modal-border"}`} role="dialog" aria-modal="true">
                {content}
                <button onClick={onClose} aria-label="Close modal">
                    Close
                </button>
            </div>
        </div>
    );
}

Modal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    content: PropTypes.node.isRequired,
    id: PropTypes.string.isRequired,
    className: PropTypes.string,
};

export default Modal;
